import React from 'react';
import routes from "./routes"
import {Switch, BrowserRouter as Router, Route} from "react-router-dom";

const Routes: React.FC = () => (
    <Router>
        <Switch>
            {/* @ts-ignore */}
            {routes?.map<{ key: any }>((props, i) => {
                    const {Component, render, path, Layout} = props
                    return <Route {...props} path={path} render={renderProps => <Layout {...renderProps} {...props} footer={true}>
                        <Component {...renderProps} {...props} />
                    </Layout>}
                    />
                }
            )}
        </Switch>
    </Router>
);

export default Routes




